import styled from '@emotion/styled';

export const ProductVariablesContainer = styled.div`
  width: 100%;
  height: 100%;
`;
